import React from "react";
import { MDBIcon } from "mdbreact";
import { Alert, Card, CardHeader, Media, Col } from "reactstrap";

const InvalidToken = () => {
  return (
    <>
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0">
            <CardHeader className="bg-transparent pb-5">
                <p style={{textAlign:"center"}}>
                  <Media object width="100" style={{marginTop: "20px"}} src={require("assets/img/brand/2073333.png")} 
                    alt="Account activation image" />
                </p>
                <Alert color="danger">
                  <span className="alert-icon">
                    <MDBIcon icon="exclamation-circle" />
                  </span>
                  <span className="alert-text"> 
                    <h4 className="alert-heading">Token Expired</h4> 
                  </span>
                  <p>Your activation link token is no longer valid.</p>
                  <hr style={{borderColor: "white"}}/>
                  <p>This can happen if the activation link clicked from email is either expired, or the URL is incorrect.</p>
                </Alert>
            </CardHeader>
        </Card>
      </Col>
    </>
  );
}

export default InvalidToken;
